import React, { useEffect, useState, useRef } from 'react';
import { Grid, Container } from '@material-ui/core';
import { HeaderHLPure } from '../../pures';
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { useTranslation } from "react-i18next";
import { ExternalDropZone, Upload } from "@progress/kendo-react-upload"
import './client-profile.css';

const ClientProfileView = (props) => {
  const uploadRef = useRef();
  const { t: tCommon, i18n } = useTranslation('common');
  const { trans, isEditing, handleInputChange, onInputChange, toggleEditMode, onStatusChange, handleImageUpload } = props
  const {
    marketNiches: marketNichesCatalog,
    name,
    setName,
    rfc,
    setRfc,
    niche,
    setNiche,
    organization,
    setOrganization,
    image,
    setImage,
    imageSrc,
    emailContact,
    setEmailContact,
    telephoneNumber,
    setTelephoneNumber,
    categoriesCatalog,
    category,
    setCategory
  } = props

  const marketNichesAux = marketNichesCatalog?.map((marketNiche) => marketNiche.name)
  const categoriesAux = categoriesCatalog?.map((category) => category.name)

  const [marketNiches, setMarketNiches] = useState([])
  const [categories, setCategories] = useState([])

  const globalContainerStyles = {
    display: "inline-block",
    justifyContent: "flex-start",
    maxWidth: "100%",
    backgroundColor: "white",
    padding: "20px",
    height: "100%",
  };
  let type;
  if (isEditing) {
    type = 'edit'
  }
  else {
    type = 'show'
  }

  const typeActionValidation = (type === 'show')
  let styleInputType = {}
  if (typeActionValidation) styleInputType = { backgroundColor: '#fafafa00', border: 'none', color: '#080808' }

  useEffect(() => {
    if (marketNichesAux) {
      const auxMarketNiches = marketNichesAux.map((marketNiche) => {
        return tCommon(marketNiche.trim())
      })

      setMarketNiches(auxMarketNiches)
    }

    if (categoriesAux) {
      const auxCategories = categoriesAux.map((category) => {
        return tCommon(category.trim())
      })

      setCategories(auxCategories)
    }
  }, [i18n.language, marketNichesCatalog, categoriesCatalog])

  return (
    <div className='recievePanelStyle'>
      <Container spacing={4} lg={12} md={12} sm={12} xs={12} style={globalContainerStyles}>
        <Grid xs={12} lg={12} md={12} sm={12} className='form-title'>
          <HeaderHLPure title={trans("title")} />
        </Grid>

        <Grid container spacing={3} className="grid-container">
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <label className="loginForm-input-label">{trans("name")}</label>
            <div className="clientProfile-input-wrapper">
              <input
                name="nombre"
                className='clientProfile-input-field'
                value={name}
                disabled={typeActionValidation}
                onChange={(event) => onInputChange(event, setName)}
                style={styleInputType}
              />
            </div>
            <label className="loginForm-input-label">{trans("niche")}</label>
            <div className="clientProfile-input-wrapper">
              {
                isEditing ? (
                  <DropDownList
                    className="eticket-dropdown-field clientProfile-input-field"
                    data={marketNiches}
                    defaultValue={tCommon(niche)}
                    disabled={typeActionValidation}
                    onChange={(event) => onInputChange(event, setNiche)}
                    style={{ fontWeight: 500 }}
                  />
                ) : (
                  <input
                    name="nombre"
                    className='clientProfile-input-field'
                    value={tCommon(niche)}
                    disabled={typeActionValidation}
                    onChange={(event) => onInputChange(event, setNiche)}
                    style={{ fontWeight: 500, backgroundColor: '#fafafa00', border: 'none', color: '#080808' }}
                  />
                )
              }
            </div>
            <label className="loginForm-input-label">{trans("rfc")}</label>
            <div className="clientProfile-input-wrapper">
              <input
                name="nombre"
                className='clientProfile-input-field'
                value={rfc}
                disabled={typeActionValidation}
                onChange={(event) => onInputChange(event, setRfc)}
                style={styleInputType}
              />
            </div>
            <label className="loginForm-input-label">{trans("category")}</label>
            <div className="clientProfile-input-wrapper">
              {
                isEditing ? (
                  <DropDownList
                    className="eticket-dropdown-field clientProfile-input-field"
                    data={categories}
                    defaultValue={tCommon(category)}
                    disabled={typeActionValidation}
                    onChange={(event) => onInputChange(event, setCategory)}
                    style={{ fontWeight: 500 }}
                  />
                ) : (
                  <input
                    name="nombre"
                    className='clientProfile-input-field'
                    value={tCommon(category)}
                    disabled={typeActionValidation}
                    onChange={(event) => onInputChange(event, setCategory)}
                    style={{ fontWeight: 500, backgroundColor: '#fafafa00', border: 'none', color: '#080808' }}
                  />
                )
              }
            </div>
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <label className="loginForm-input-label">{trans("companyName")}</label>
            <div className="clientProfile-input-wrapper">
              <input
                name="nombre"
                className='clientProfile-input-field'
                value={organization}
                disabled={typeActionValidation}
                onChange={(event) => onInputChange(event, setOrganization)}
                style={styleInputType}
              />
            </div>
            <label className="loginForm-input-label">{trans("contactEmail")}</label>
            <div className="clientProfile-input-wrapper">
              <input
                name="nombre"
                className='clientProfile-input-field'
                value={emailContact}
                disabled={typeActionValidation}
                onChange={(event) => onInputChange(event, setEmailContact)}
                style={styleInputType}
              />
            </div>
            <label className="loginForm-input-label">{trans("contactNumber")}</label>
            <div className="clientProfile-input-wrapper">
              <input
                name="nombre"
                className='clientProfile-input-field'
                type='number'
                value={telephoneNumber}
                disabled={typeActionValidation}
                onChange={(event) => onInputChange(event, setTelephoneNumber)}
                style={styleInputType}
              />
            </div>
            <label className="loginForm-input-label">{trans("image")}</label>
            <div className="clientProfile-input-wrapper">
              <div className="upload-image-container">
                {
                  isEditing ? (
                    <>
                      {
                        imageSrc ? (
                          <div className='clientProfile-image-container'>
                            <img className="clientProfile-image-display" src={imageSrc} />
                          </div>
                        ) : (
                          <ExternalDropZone uploadRef={uploadRef} style={{ border: '3px dashed rgb(0 0 0 / 20%)', backgroundColor: '#00000000', color: 'rgb(0 0 0 / 40%)', fontWeight: '600', fontFamily: '"Quicksand"', height: "200px" }} />
                        )
                      }
                      <Upload className='upload-wrapper'
                        onStatusChange={onStatusChange}
                        ref={uploadRef}
                        batch={false}
                        multiple={false}
                        defaultFiles={[]}
                        withCredentials={false}
                        autoUpload={false}
                        showActionButtons={false}
                        accept=".heic,.png,.jpg,.jpeg,.mov"
                        onAdd={(ev) => {
                          if (ev.target.files[0]) {
                            const file = ev.target.files[0].getRawFile();
                            handleImageUpload(file);
                            setImage(file);
                          }
                        }}
                        onRemove={() => {
                          handleImageUpload(null);
                          setImage(null);
                        }}
                      />
                    </>
                  ) : (
                    <div className='clientProfile-image-container'>
                      <img className="clientProfile-image-display" src={image} />
                    </div>
                  )
                }
              </div>
            </div>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            {!isEditing ? (
              <div className="buttons-container">
                <div style={{ boxSizing: 'border-box', paddingRight: '10px' }}>
                  <button className="buttonHLPure buttonHLPure-primary outlined space-button" onClick={toggleEditMode}>{trans("editButton")}</button>
                </div>
              </div>
            ) :
              (
                <div className="buttons-container">
                  <div style={{ boxSizing: 'border-box', paddingRight: '24px' }}>
                    <button className="buttonHLPure buttonHLPure-error outlined space-button" onClick={toggleEditMode}>{trans("cancelButton")}</button>
                  </div>
                  <div style={{ boxSizing: 'border-box', paddingRight: '10px' }}>
                    <button className="buttonHLPure buttonHLPure-primary outlined space-button" onClick={handleInputChange}>{trans("acceptButton")}</button>
                  </div>
                </div>
              )
            }
          </Grid>
        </Grid>

      </Container>
    </div >
  );
};

export { ClientProfileView as default };